import { translate } from 'services/translationService';
import { appRoute } from 'shared/constants/routes';

type TooltipType = 'visibility' | 'position' | 'query';

const capitalize = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

export function getScoreTooltipText(type: TooltipType) {
  const path =
    typeof window !== 'undefined'
      ? decodeURIComponent(window.location.pathname)
      : '';

  const isBusinessBase = path === appRoute('/dashboard');
  const isBusinessCompetitor =
    path === appRoute('/dashboard/competitor-detail');
  const hasCompetitor = path.includes('/competitor-detail');

  let scope:
    | 'business'
    | 'businessCompetitor'
    | 'service'
    | 'serviceCompetitor' = 'service';

  if (isBusinessBase) {
    scope = 'business';
  } else if (isBusinessCompetitor) {
    scope = 'businessCompetitor';
  } else if (hasCompetitor) {
    // Any competitor detail outside exact business competitor route is treated as service competitor
    scope = 'serviceCompetitor';
  } else {
    scope = 'service';
  }

  const key = `${scope}${capitalize(type)}Tooltip`;

  // Fallback to generic '<type>Tooltip' if scoped key is missing
  return translate(key, '_global', translate(`${type}Tooltip`, '_global', ''));
}
